// extracted by mini-css-extract-plugin
export default {"dialog":"ConfirmDelete_dialog__4JODY","buttons":"ConfirmDelete_buttons__ofxxJ","dialogButton":"ConfirmDelete_dialogButton__e6WNh","cancelButton":"ConfirmDelete_cancelButton__YBI0Z"};